/** Route helpers shared by both sites' routers (the contributor app and ops). */

export interface SignInSearch {
  next?: string
  reason?: 'expired' | 'signed-out' | 'provider'
  email?: string
}

/** Only same-origin paths may be used as a post-sign-in destination. */
export function safeNext(next: unknown): string | undefined {
  return typeof next === 'string' && next.startsWith('/') && !next.startsWith('//') && !next.startsWith('/signin') ? next : undefined
}

/** Search validators return optional keys, so links only pass what they set. */
export function opt<T extends object>(fn: (s: Record<string, unknown>) => T): (s: Record<string, unknown>) => Partial<T> {
  return (s) => {
    const out = fn(s) as Record<string, unknown>
    for (const k of Object.keys(out)) if (out[k] === undefined) delete out[k]
    return out as Partial<T>
  }
}
